import { api } from "@shared/api/client";
import type {
  Iso2700127701PlanAnexoA,
  Iso2700127701PlanPayload,
  Iso2700127701SoaControl,
  Iso2700127701SoaFilters,
  Iso2700127701SoaPayload,
  Iso2700127701SoaResponse,
} from "../../../types/iso2700127701";
import type {
  Iso2700127701ControlModificacion,
  Iso2700127701ControlModificacionPayload,
} from "../../../types/control-modificaciones";

const BASE_URL = "/certificaciones/iso-27001-27701/soa";

export async function getIso2700127701Soa(filters: Iso2700127701SoaFilters, signal?: AbortSignal) {
  const { data } = await api.get<Iso2700127701SoaResponse>(BASE_URL, {
    params: Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== "")),
    signal,
  });
  return data;
}

export async function createIso2700127701SoaControl(payload: Iso2700127701SoaPayload) {
  const { data } = await api.post<{ ok: boolean; data: Iso2700127701SoaControl }>(`${BASE_URL}/controles`, payload);
  return data.data;
}

export async function updateIso2700127701SoaControl(id: number, payload: Iso2700127701SoaPayload) {
  const { data } = await api.put<{ ok: boolean; data: Iso2700127701SoaControl }>(`${BASE_URL}/controles/${id}`, payload);
  return data.data;
}

export async function deleteIso2700127701SoaControl(id: number) {
  await api.delete(`${BASE_URL}/controles/${id}`);
}

export async function createIso2700127701PlanAnexoA(payload: Iso2700127701PlanPayload) {
  const { data } = await api.post<{ ok: boolean; data: Iso2700127701PlanAnexoA }>(`${BASE_URL}/plan-anexo-a`, payload);
  return data.data;
}

export async function updateIso2700127701PlanAnexoA(id: number, payload: Iso2700127701PlanPayload) {
  const { data } = await api.put<{ ok: boolean; data: Iso2700127701PlanAnexoA }>(`${BASE_URL}/plan-anexo-a/${id}`, payload);
  return data.data;
}

export async function deleteIso2700127701PlanAnexoA(id: number) {
  await api.delete(`${BASE_URL}/plan-anexo-a/${id}`);
}

export async function createIso2700127701SoaControlModificacion(payload: Iso2700127701ControlModificacionPayload) {
  const { data } = await api.post<{ ok: boolean; data: Iso2700127701ControlModificacion }>(`${BASE_URL}/control-modificaciones`, payload);
  return data.data;
}

export async function updateIso2700127701SoaControlModificacion(id: number, payload: Iso2700127701ControlModificacionPayload) {
  const { data } = await api.put<{ ok: boolean; data: Iso2700127701ControlModificacion }>(`${BASE_URL}/control-modificaciones/${id}`, payload);
  return data.data;
}

export async function deleteIso2700127701SoaControlModificacion(id: number) {
  await api.delete(`${BASE_URL}/control-modificaciones/${id}`);
}
